document.addEventListener('DOMContentLoaded', function() {
  const productCards = document.querySelectorAll('.product-card__image-wrapper');
  
  productCards.forEach(card => {
    new Swiper(card, {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
      },
    });
  });
});